import { useMutation } from "@tanstack/react-query"
import axios from "axios"

export function useUserOtpReveal() {
  return useMutation({
    mutationFn: async ({ userId }) => {
      return await axios({
        url: [process.env.REACT_APP_API_URL, '/user-otp-reveal'].join(''),
        method: 'POST',
        withCredentials: true,
        data: { userId },
      })
        .then(response => response?.data?.data)
        .catch(error => {
          throw error?.response?.data ?? error
        })
    },
  })
}
